<template>
  <div class="container">
      <div class="display-5 my-5"><span>REGULAMIN ŚWIADCZENIA USŁUG DROGĄ ELEKTRONICZNĄ</span></div>
      <p><strong><span>obowiązujący od dnia: <span data-placeholder-token="true" class="text-token-text-primary cursor-text rounded-sm" style="background-color: color-mix(in srgb, var(--theme-user-selection-bg, var(--selection)) 30%, transparent); padding-top: 4px; padding-bottom: 4px;">[DD.MM.RRRR]</span></span></strong></p>
      <h2><span>§1. Postanowienia ogólne</span></h2>
      <ol data-spread="false" start="1">
        <li><p><span>Niniejszy Regulamin określa zasady korzystania z serwisu internetowego </span><strong><span><span data-placeholder-token="true" class="text-token-text-primary cursor-text rounded-sm"
                                                                                                                       style="background-color: color-mix(in srgb, var(--theme-user-selection-bg, var(--selection)) 30%, transparent); padding-top: 4px; padding-bottom: 4px;">[Nazwa Serwisu]</span></span></strong><span>, dostępnego pod adresem </span><strong><span>[</span></strong><a
            href="https://twojadomena.pl"><strong><span>https://twojadomena.pl</span></strong></a><strong><span>]</span></strong><span>, w szczególności zasady zakładania kont użytkowników oraz dokonywania rezerwacji.</span></p></li>
        <li><p><span>Właścicielem i administratorem Serwisu jest:</span></p>
          <ul data-spread="false">
            <li><p><span>Nazwa firmy: </span><strong><span><span data-placeholder-token="true" class="text-token-text-primary cursor-text rounded-sm" style="background-color: color-mix(in srgb, var(--theme-user-selection-bg, var(--selection)) 30%, transparent); padding-top: 4px; padding-bottom: 4px;">[Nazwa firmy]</span></span></strong></p></li>
            <li><p><span>Forma prawna: </span><strong><span><span data-placeholder-token="true" class="text-token-text-primary cursor-text rounded-sm" style="background-color: color-mix(in srgb, var(--theme-user-selection-bg, var(--selection)) 30%, transparent); padding-top: 4px; padding-bottom: 4px;">[np. jednoosobowa działalność gospodarcza / spółka z o.o.]</span></span></strong></p></li>
            <li><p><span>Adres siedziby: </span><strong><span><span data-placeholder-token="true" class="text-token-text-primary cursor-text rounded-sm" style="background-color: color-mix(in srgb, var(--theme-user-selection-bg, var(--selection)) 30%, transparent); padding-top: 4px; padding-bottom: 4px;">[Adres]</span></span></strong></p></li>
            <li><p><span>NIP: </span><strong><span><span data-placeholder-token="true" class="text-token-text-primary cursor-text rounded-sm" style="background-color: color-mix(in srgb, var(--theme-user-selection-bg, var(--selection)) 30%, transparent); padding-top: 4px; padding-bottom: 4px;">[NIP]</span></span></strong></p></li>
            <li><p><span>REGON (opcjonalnie): </span><strong><span><span data-placeholder-token="true" class="text-token-text-primary cursor-text rounded-sm" style="background-color: color-mix(in srgb, var(--theme-user-selection-bg, var(--selection)) 30%, transparent); padding-top: 4px; padding-bottom: 4px;">[REGON]</span></span></strong></p></li>
            <li><p><span>Adres e-mail: </span><strong><span>[</span></strong><a href="mailto:kontakt@domena.pl"><strong><span>kontakt@domena.pl</span></strong></a><strong><span>]</span></strong></p></li>
          </ul>
        </li>
        <li><p><span>Regulamin stanowi regulamin świadczenia usług drogą elektroniczną w rozumieniu obowiązujących przepisów prawa.</span></p></li>
        <li><p><span>Każdy użytkownik zobowiązany jest do zapoznania się z treścią Regulaminu przed rozpoczęciem korzystania z Serwisu.</span></p></li>
      </ol>
      <div contenteditable="false">
        <hr>
      </div>
      <h2><span>§2. Definicje</span></h2>
      <p><span>Na potrzeby niniejszego Regulaminu przyjmuje się następujące definicje:</span></p>
      <ol data-spread="false" start="1">
        <li><p><strong><span>Administrator</span></strong><span> – właściciel Serwisu wskazany w §1.</span></p></li>
        <li><p><strong><span>Serwis</span></strong><span> – strona internetowa dostępna pod adresem wskazanym w §1.</span></p></li>
        <li><p><strong><span>Użytkownik</span></strong><span> – osoba fizyczna posiadająca konto w Serwisie.</span></p></li>
        <li><p><strong><span>Konto</span></strong><span> – indywidualny profil Użytkownika umożliwiający korzystanie z funkcji Serwisu.</span></p></li>
        <li><p><strong><span>Rezerwacja</span></strong><span> – zgłoszenie dokonane przez Użytkownika za pośrednictwem Serwisu zgodnie z jego funkcjonalnością.</span></p></li>
      </ol>
      <div contenteditable="false">
        <hr>
      </div>
      <h2><span>§3. Rodzaj i zakres świadczonych usług</span></h2>
      <ol data-spread="false" start="1">
        <li><p><span>Administrator świadczy drogą elektroniczną usługi polegające na:</span></p>
          <ul data-spread="false">
            <li><p><span>umożliwieniu założenia konta użytkownika,</span></p></li>
            <li><p><span>umożliwieniu logowania do konta,</span></p></li>
            <li><p><span>umożliwieniu składania i zarządzania rezerwacjami,</span></p></li>
            <li><p><span>przechowywaniu historii rezerwacji przypisanej do konta.</span></p></li>
          </ul>
        </li>
        <li><p><span>Korzystanie z Serwisu jest bezpłatne, chyba że wyraźnie wskazano inaczej.</span></p></li>
      </ol>
      <div contenteditable="false">
        <hr>
      </div>
      <h2><span>§4. Rejestracja konta</span></h2>
      <ol data-spread="false" start="1">
        <li><p><span>Założenie konta wymaga podania adresu e-mail oraz utworzenia hasła.</span></p></li>
        <li><p><span>Użytkownik zobowiązuje się podać prawdziwy i aktualny adres e-mail.</span></p></li>
        <li><p><span>Jeden adres e-mail może być przypisany do jednego konta, chyba że Administrator postanowi inaczej.</span></p></li>
        <li><p><span>Użytkownik ponosi odpowiedzialność za zachowanie poufności danych logowania.</span></p></li>
        <li><p><span>Administrator może odmówić utworzenia konta lub usunąć konto w przypadku naruszenia Regulaminu.</span></p></li>
      </ol>
      <div contenteditable="false">
        <hr>
      </div>
      <h2><span>§5. Zasady dokonywania rezerwacji</span></h2>
      <ol data-spread="false" start="1">
        <li><p><span>Rezerwacje dokonywane są za pośrednictwem funkcjonalności dostępnych w Serwisie.</span></p></li>
        <li><p><span>Po dokonaniu rezerwacji zostaje ona przypisana do konta Użytkownika.</span></p></li>
        <li><p><span>Użytkownik może przeglądać historię swoich rezerwacji po zalogowaniu.</span></p></li>
        <li><p><span>Szczegółowe zasady anulowania lub zmiany rezerwacji wynikają z opisu usługi lub informacji przedstawionych podczas składania rezerwacji.</span></p></li>
        <li><p><span>Administrator zastrzega sobie prawo do anulowania rezerwacji w przypadkach uzasadnionych awarią systemu, błędami technicznymi lub innymi wyjątkowymi okolicznościami.</span></p></li>
      </ol>
      <div contenteditable="false">
        <hr>
      </div>
      <h2><span>§6. Obowiązki Użytkownika</span></h2>
      <p><span>Użytkownik zobowiązuje się do:</span></p>
      <ol data-spread="false" start="1">
        <li><p><span>korzystania z Serwisu zgodnie z obowiązującym prawem,</span></p></li>
        <li><p><span>niepodejmowania działań mogących zakłócić działanie Serwisu,</span></p></li>
        <li><p><span>nieudostępniania swojego konta osobom trzecim,</span></p></li>
        <li><p><span>podawania prawdziwych danych podczas korzystania z Serwisu.</span></p></li>
      </ol>
      <div contenteditable="false">
        <hr>
      </div>
      <h2><span>§7. Prawa Administratora</span></h2>
      <p><span>Administrator ma prawo:</span></p>
      <ol data-spread="false" start="1">
        <li><p><span>prowadzić prace konserwacyjne powodujące czasową niedostępność Serwisu,</span></p></li>
        <li><p><span>blokować lub usuwać konta naruszające Regulamin,</span></p></li>
        <li><p><span>wprowadzać zmiany funkcjonalności Serwisu,</span></p></li>
        <li><p><span>podejmować działania mające na celu zapewnienie bezpieczeństwa danych i poprawnego działania Serwisu.</span></p></li>
      </ol>
      <div contenteditable="false">
        <hr>
      </div>
      <h2><span>§8. Dane osobowe</span></h2>
      <ol data-spread="false" start="1">
        <li><p><span>Administratorem danych osobowych jest Administrator wskazany w §1.</span></p></li>
        <li><p><span>Dane osobowe przetwarzane są w celu:</span></p>
          <ul data-spread="false">
            <li><p><span>prowadzenia konta użytkownika,</span></p></li>
            <li><p><span>realizacji i obsługi rezerwacji,</span></p></li>
            <li><p><span>zapewnienia bezpieczeństwa korzystania z Serwisu.</span></p></li>
          </ul>
        </li>
        <li><p><span>Zakres przetwarzanych danych obejmuje w szczególności adres e-mail oraz dane związane z dokonanymi rezerwacjami.</span></p></li>
        <li><p><span>Dane nie są wykorzystywane do celów marketingowych, chyba że Użytkownik wyrazi odrębną zgodę.</span></p></li>
        <li><p><span>Szczegółowe informacje dotyczące przetwarzania danych osobowych znajdują się w </span><strong><span>Polityce Prywatności</span></strong><span>.</span></p></li>
      </ol>
      <div contenteditable="false">
        <hr>
      </div>
      <h2><span>§9. Odpowiedzialność</span></h2>
      <ol data-spread="false" start="1">
        <li><p><span>Administrator dokłada należytej staranności w celu zapewnienia prawidłowego działania Serwisu.</span></p></li>
        <li><p><span>Administrator nie ponosi odpowiedzialności za:</span></p>
          <ul data-spread="false">
            <li><p><span>przerwy wynikające z prac technicznych,</span></p></li>
            <li><p><span>awarie niezależne od Administratora,</span></p></li>
            <li><p><span>skutki podania przez Użytkownika nieprawidłowych danych.</span></p></li>
          </ul>
        </li>
        <li><p><span>Administrator nie odpowiada za szkody wynikające z udostępnienia przez Użytkownika danych logowania osobom trzecim.</span></p></li>
      </ol>
      <div contenteditable="false">
        <hr>
      </div>
      <h2><span>§10. Reklamacje</span></h2>
      <ol data-spread="false" start="1">
        <li><p><span>Reklamacje dotyczące działania Serwisu można składać drogą elektroniczną na adres:</span><br><strong><span>[</span></strong><a href="mailto:kontakt@domena.pl"><strong><span>kontakt@domena.pl</span></strong></a><strong><span>]</span></strong></p></li>
        <li><p><span>Reklamacja powinna zawierać:</span></p>
          <ul data-spread="false">
            <li><p><span>adres e-mail przypisany do konta,</span></p></li>
            <li><p><span>opis problemu,</span></p></li>
            <li><p><span>datę jego wystąpienia (jeżeli jest znana).</span></p></li>
          </ul>
        </li>
        <li><p><span>Administrator rozpatruje reklamację w terminie do </span><strong><span>14 dni</span></strong><span> od dnia jej otrzymania.</span></p></li>
        <li><p><span>O sposobie rozpatrzenia reklamacji Użytkownik zostanie poinformowany drogą elektroniczną.</span></p></li>
      </ol>
      <div contenteditable="false">
        <hr>
      </div>
      <h2><span>§11. Zmiany Regulaminu</span></h2>
      <ol data-spread="false" start="1">
        <li><p><span>Administrator może zmienić Regulamin z ważnych przyczyn, w szczególności:</span></p>
          <ul data-spread="false">
            <li><p><span>zmiany przepisów prawa,</span></p></li>
            <li><p><span>zmian funkcjonalności Serwisu,</span></p></li>
            <li><p><span>zmian organizacyjnych lub technicznych.</span></p></li>
          </ul>
        </li>
        <li><p><span>O zmianach Regulaminu Użytkownicy zostaną poinformowani poprzez publikację nowej wersji w Serwisie.</span></p></li>
        <li><p><span>Zmiany wchodzą w życie z dniem wskazanym przez Administratora, nie wcześniej niż po opublikowaniu nowej wersji Regulaminu.</span></p></li>
      </ol>
      <div contenteditable="false">
        <hr>
      </div>
      <h2><span>§12. Postanowienia końcowe</span></h2>
      <ol data-spread="false" start="1">
        <li><p><span>W sprawach nieuregulowanych niniejszym Regulaminem zastosowanie mają przepisy prawa polskiego oraz odpowiednie przepisy prawa Unii Europejskiej, w szczególności:</span></p>
          <ul data-spread="false">
            <li><p><span>Kodeks cywilny,</span></p></li>
            <li><p><span>ustawa o świadczeniu usług drogą elektroniczną,</span></p></li>
            <li><p><span>Rozporządzenie Parlamentu Europejskiego i Rady (UE) 2016/679 (RODO).</span></p></li>
          </ul>
        </li>
        <li><p><span>Regulamin jest dostępny nieodpłatnie na stronie internetowej Serwisu w sposób umożliwiający jego pobranie, zapisanie oraz wydrukowanie.</span></p></li>
        <li><p><span>Regulamin obowiązuje od dnia </span><strong><span><span data-placeholder-token="true" class="text-token-text-primary cursor-text rounded-sm" style="background-color: color-mix(in srgb, var(--theme-user-selection-bg, var(--selection)) 30%, transparent); padding-top: 4px; padding-bottom: 4px;">[DD.MM.RRRR]</span></span></strong><span>.</span></p></li>
      </ol>
    </div>
</template>

<script>
export default {
  name: "TermsConditionsPage"
}
</script>

<style scoped>

</style>